import React from 'react'

import { cn } from '@/utils/mergeClassNames'

import type { WizardStep, WizardStepKey } from '../types'

type WelcomeWizardStepButtonProps = {
  isActive: boolean
  isChild?: boolean
  isCompleted: boolean
  onSelect: (stepKey: WizardStepKey) => void
  step: WizardStep
}

const WelcomeWizardStepButton = ({
  isActive,
  isChild = false,
  isCompleted,
  onSelect,
  step,
}: WelcomeWizardStepButtonProps) => {
  return (
    <button
      className={cn(
        'flex min-h-[54px] w-full items-start gap-[10px] py-4 pr-4 text-left text-sm tracking-[0.25px]',
        isChild ? 'pl-8' : 'pl-4',
        isActive
          ? 'bg-[#333] font-semibold text-white'
          : 'hover:bg-neutral-100',
        !isActive && (isCompleted ? 'text-[#333333]' : 'text-[#666]')
      )}
      onClick={() => onSelect(step.key)}
      type="button"
    >
      <span
        className={cn(
          'mt-1.5 h-2 w-2 shrink-0 rounded-full',
          isActive ? 'bg-white' : isCompleted ? 'bg-[#4CAF50]' : 'bg-[#d9d9d9]'
        )}
      />
      <span>{step.optional ? `[Optional] ${step.label}` : step.label}</span>
    </button>
  )
}

export default WelcomeWizardStepButton
